module.exports = __webpack_public_path__ + "images/favicon-9c8664.png";